import { FaExclamationCircle } from "react-icons/fa";

const ErrorPage = () => {
  const handleGoBack = () => {
    window.location.href = "/shop";
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <FaExclamationCircle className="text-red-500 text-6xl" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Something went wrong!
        </h1>
        <p className="text-gray-600 mb-6">Please try again.</p>
        <button
          onClick={handleGoBack}
          className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-md"
        >
          Go Back to Shop
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
